import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import Imagen1 from "../../../images/modulo12/matricula.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[1];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[2].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[2].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[0].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[0].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-12 mb-1">
          <ul className="">
            <li>Lee el siguiente diálogo:</li>
          </ul>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-lg-10 col-12">
          <p className="mt-5">
            ¿Qué problema enfrenta Elmer Puémape? Escribe tu respuesta aquí:
          </p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <ul className="mt-5">
        <li>
          ¿Qué harías tú si fueras el director del colegio? Escoge una opción.
          Luego, explica a tu compañero, compañera o familiar por qué crees que
          es la mejor.
        </li>
      </ul>
      <div className="row mb-3">
        <div className="col-12 col-md-4">
          <Card>
            <div>Opción 1:</div>
            <p>
              Yo haría un sistema de becas. Los niños y las niñas que no pueden
              pagar reciben una beca y pueden seguir estudiando.
            </p>
          </Card>
        </div>
        <div className="col-12 col-md-4">
          <Card>
            <div>Opción 2:</div>
            <p>
              Yo le aconsejaría que se matricule en una escuela del Estado. Hay
              unas muy buenas.
            </p>
          </Card>
        </div>
        <div className="col-12 col-md-4">
          <Card>
            <div>Opción 3:</div>
            <p>
              Yo pondría la pensión más barata para todos. No importa que ya no
              podamos comprar libros o que les paguemos menos a los profesores.
            </p>
          </Card>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación de la actividad: Lee el siguiente diálogo.
            Pídales a niños o niñas que lean el diálogo.
          </li>

          <li>
            Pídales que observen la imagen y pregunte:
            <ul>
              <li>
                {" "}
                <i>
                  “¿Quiénes están en la imagen? (Posible respuesta: Un director,
                  posiblemente de escuela, y un padre de familia). ¿Qué está
                  tratando de hacer el padre de familia? (Es posible que quiera
                  matricular a su hijo(a) en la escuela).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: ¿Qué problema enfrenta Elmer Puémape?
            Escribe tu respuesta aquí. Converse con los niños y niñas acerca de
            cuál es el problema que sufre Elmer Puémape. Traten de llegar a un
            consenso. Por ejemplo:
            <ul>
              <li>
                <i>
                  "Elmer Puémape desea matrícula a su hijo o hija en la escuela
                  pero no puede pagar la matrícula y la mensualidad”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la primera indicación: ¿Qué harías tú si fueras el director del
            colegio? Escoge una opción. Luego, explica a tu compañero, compañera
            o familiar por qué crees que es la mejor.
          </li>
          <li>
            Pídales a niños y niñas que trabajen en parejas o con un familiar y lean
            las 3 opciones.
          </li>
          <li>
            Aclare que cada niño o niña tiene que explicar por qué la opción
            escogida es la mejor. También debe señalar si está o no de acuerdo
            con la opción escogida por su pareja o familiar. Por ejemplo:
            <ul>
              <li>
                <i>
                  “José: Yo estoy de acuerdo con la opción 1 porque así le
                  daríamos una oportunidad de estudiar a alguien en una escuela
                  de calidad.
                </i>
              </li>
              <li>
                <i>
                  Milagros: Yo no estoy de acuerdo con José porque por pagar las
                  becas de repente nos quedamos sin otras cosas importantes en
                  la escuela. Me parece mejor la opción 2 porque así puede
                  recibir una buena educación sin pagar un alto costo”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Retome algunas respuestas dadas y destaque los argumentos
            presentados. Recuerde que eso es lo más importante pues todas las
            opciones son válidas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
